import { gql, useMutation } from "@apollo/client";

export const MUTATION_EDIT_ACTION = gql`
  mutation editAction(
    $actionId: ID!
    $description: String
    $qualityCheckStatus: QualityCheckStatus
    $actionType: ActionType
  ) {
    editAction(
      input: {
        actionId: $actionId
        description: $description
        qualityCheckStatus: $qualityCheckStatus
        actionType: $actionType
      }
    ) {
      id
    }
  }
`;

export function useEditActionMutation() {
  const [
    editActionMutation,
    { loading: isLoadingEditCommentMutation, error: errorEditActionMutation }
  ] = useMutation(MUTATION_EDIT_ACTION, {
    onError(err: any) {
      console.log(err);
    }
  });

  return {
    editActionMutation,
    isLoadingEditCommentMutation,
    errorEditActionMutation
  };
}
